import type { FC, ReactNode } from 'react'

import { Swipeable } from '@skytech/ui'
import { twJoin } from 'tailwind-merge'

import './page.scss'

const Page: FC<{
  children: ReactNode
  onSwipedLeft?: () => void
  pageWrapperClassName?: string
  className?: string
  translate?: 'yes' | 'no' | undefined
}> = ({ onSwipedLeft, className, pageWrapperClassName, children, translate, ...restOfProps }) => (
  <Swipeable
    className={twJoin('page', className)}
    id="page"
    onSwipedLeft={onSwipedLeft}
    {...restOfProps}
  >
    <div className={twJoin('page__wrapper', pageWrapperClassName)} translate={translate}>
      {children}
    </div>
  </Swipeable>
)

export default Page
